import { render } from "./SelectTraineesModal.vue?vue&type=template&id=b34bdc56&scoped=true"
import script from "./SelectTraineesModal.vue?vue&type=script&lang=js"
export * from "./SelectTraineesModal.vue?vue&type=script&lang=js"

import "./SelectTraineesModal.vue?vue&type=style&index=0&id=b34bdc56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b34bdc56"]])

export default __exports__